<form [formGroup]="formGroup">
  <div class="feedback-step">
    <div class="step-header">
      <div class="title-with-dropdown">
        <h3 style="margin: 0">{{ stepData.categoryTitle }}</h3>

        <div class="behavior-dropdown" *ngIf="caseBehvaiors.length > 0">
          <div class="behavior-controls-row">
            <span
              class="fw-400 observed-checkbox"
              nz-checkbox
              [nzChecked]="isCurrentBehaviorNotObserved"
              [nzDisabled]="stepData.isViewMode"
              (nzCheckedChange)="onNotObservedChange($event)">
              Not observed at this period
            </span>
          </div>
        </div>
      </div>
    </div>

    <nz-tabset
      class="behavior-tabset"
      [nzSelectedIndex]="getSelectedBehaviorTabIndex()"
      (nzSelectedIndexChange)="onBehaviorTabIndexChange($event)">
      <nz-tab
        *ngFor="let behavior of caseBehvaiors"
        [nzTitle]="behavior.behaviorCategoryName">
      </nz-tab>
    </nz-tabset>
    <div
      class="questions-container"
      *ngIf="!isCurrentBehaviorNotObserved; else notObservedTemplate">
      <div formArrayName="questionResponses">
        <div
          *ngFor="let question of stepData.questions; let i = index"
          class="question-item"
          [formGroupName]="getQuestionIndex(question.id)">
          <div class="header-with-cta mb-16">
            <div class="quetion-badge">
              <span class="badge"
                >{{ i + 1 }}/{{ stepData.questions.length }}</span
              >
              <div *ngIf="question.id === 7; else checkQuestion8">
                <h3 class="title s-18">Current Focus/Challenges</h3>
              </div>
              <ng-template #checkQuestion8>
                <div *ngIf="question.id === 8; else normalQuestion">
                  <h3 class="title s-18">Academic Impact</h3>
                </div>
              </ng-template>
              <ng-template #normalQuestion>
                <h3 class="title s-18">{{ question.question }}</h3>
              </ng-template>
            </div>
          </div>

          <div [ngSwitch]="getQuestionType(question)">
            <div *ngSwitchCase="'scale'" class="radio-wrapper">
              <nz-form-item *ngIf="question.id === 8">
                <nz-form-label nzRequired>{{
                  question.question
                }}</nz-form-label>
              </nz-form-item>
              <nz-form-control
                [nzErrorTip]="getQuestionErrorTip(question.id)"
                [nzValidateStatus]="getQuestionValidationStatus(question.id)"
                [nzHasFeedback]="true">
                <nz-radio-group
                  formControlName="ratingScale"
                  class="radio-group scale-group"
                  [disabled]="
                    stepData.isViewMode || isCurrentBehaviorNotObserved
                  ">
                  <span nz-radio [nzValue]="1" class="box-radio">
                    <span class="radio-label">{{
                      getScaleLabel(question, 1)
                    }}</span>
                  </span>
                  <span nz-radio [nzValue]="2" class="box-radio">
                    <span class="radio-label">{{
                      getScaleLabel(question, 2)
                    }}</span>
                  </span>
                  <span nz-radio [nzValue]="3" class="box-radio">
                    <span class="radio-label">{{
                      getScaleLabel(question, 3)
                    }}</span>
                  </span>
                  <span nz-radio [nzValue]="4" class="box-radio">
                    <span class="radio-label">{{
                      getScaleLabel(question, 4)
                    }}</span>
                  </span>
                  <span nz-radio [nzValue]="5" class="box-radio">
                    <span class="radio-label">{{
                      getScaleLabel(question, 5)
                    }}</span>
                  </span>
                </nz-radio-group>
              </nz-form-control>
            </div>

            <div *ngSwitchCase="'text'" class="text-input-container">
              <nz-form-item>
                <nz-form-label>{{ question.question }}</nz-form-label>
                <nz-form-control
                  [nzErrorTip]="getQuestionErrorTip(question.id)"
                  [nzValidateStatus]="getQuestionValidationStatus(question.id)"
                  [nzHasFeedback]="true">
                  <input
                    formControlName="description"
                    nz-input
                    placeholder="Enter answer"
                    [disabled]="
                      stepData.isViewMode || isCurrentBehaviorNotObserved
                    " />
                </nz-form-control>
                <div class="mt-3 remaining-text">
                  {{ getDescriptionLength(question.id) }} of 500 characters used
                </div>
              </nz-form-item>
            </div>
          </div>

          <hr class="question-divider" />
        </div>
      </div>
    </div>

    <ng-template #notObservedTemplate>
      <div class="questions-container">
        <p class="hint-text mb-16">
          This behavior is marked as not observed for this period. Questions are
          skipped.
        </p>
      </div>
    </ng-template>
  </div>
  <app-behavior-graph
    [bhevaiorId]="selectedBehaviorId || 0"></app-behavior-graph>
</form>
